import { TChatViewAction } from '../actions/types';
import { IChatViewState } from '../types';
import { getChatViewInitialState } from '../constants';
import * as deepFreeze from 'deep-freeze';
import {
    AT_GROUP_UPDATE,
    AT_GROUPS_SET, AT_CHAT_DELETE,
    AT_CHAT_UPDATE,
    AT_CHATS_SET,
    AT_OPENED_GROUP_ID_SET,
    AT_OPENED_CHAT_ID_SET, AT_GROUP_DELETE
} from '../actions/constants';
import { setChatOpenedGroupIdLocalStorage } from '../localStorage/actions/setChatOpenedGroupIdLocalStorage';
import { setChatOpenedChatIdLocalStorage } from '../localStorage/actions/setChatOpenedChatIdLocalStorage';
import { chatGroupReducer } from '../../chatGroup/reducers/chatGroupReducer';
import { chatReducer } from '../../chat/reducers/chatReducer';

const initialState: IChatViewState = getChatViewInitialState();

const _chatViewReducer = (
    state = initialState,
    action: TChatViewAction
): IChatViewState => {
    switch (action.type) {
        case AT_OPENED_GROUP_ID_SET: {
            return {
                ...state,
                openedGroupId: action.id,
            }
        }
        case AT_OPENED_CHAT_ID_SET: {
            return {
                ...state,
                openedChatId: action.id,
            }
        }
        case AT_CHATS_SET: {
            return {
                ...state,
                chats: {
                    ...state.chats,
                    ...action.chats,
                },
            }
        }
        case AT_GROUPS_SET: {
            return {
                ...state,
                groups: {
                    ...state.groups,
                    ...action.groups,
                },
            }
        }
        case AT_GROUP_UPDATE: {
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.id]: chatGroupReducer(state.groups[action.id], action.action),
                },
            }
        }
        case AT_GROUP_DELETE: {
            const stateNew = {...state.groups};
            const { group } = action;
            if (group) {
                delete stateNew[group.id];
            }
            return {
                ...state,
                groups: stateNew
            };
        }
        case AT_CHAT_UPDATE: {
            return {
                ...state,
                chats: {
                    ...state.chats,
                    [action.id]: chatReducer(state.chats[action.id], action.action),
                },
            }
        }

        case AT_CHAT_DELETE: {
            const stateNew = {...state.chats};
            const { chat } = action;
            if (chat) {
                delete stateNew[chat.id];
            }
            return {
                ...state,
                chats: stateNew
            };
        }
        default:
            return state;
    }
};

export const chatViewReducer = (
    state = initialState,
    action: TChatViewAction
): IChatViewState => {
    let newState: IChatViewState;
    // @ts-ignore
    if(window.Settings.development) {
        // @ts-ignore
        newState = deepFreeze(_chatViewReducer(state, action));
    } else {
        newState = _chatViewReducer(state, action);
    }

    if (newState !== state) {
        if (action.type === AT_OPENED_GROUP_ID_SET) {
            setChatOpenedGroupIdLocalStorage(newState.openedGroupId);
        }
        if (action.type === AT_OPENED_CHAT_ID_SET) {
            setChatOpenedChatIdLocalStorage(newState.openedChatId);
        }
    }

    return newState;
};
